import { apiPost } from '@/services/api/client';

export type RemoteShiftRow = {
  shiftId?: string;
  dateStarted?: string;
  date?: string;
  amount?: string;
} & Record<string, unknown>;

export async function getPreviousShifts(userId: string): Promise<RemoteShiftRow[]> {
  const body = await apiPost<unknown>(
    'getShifts',
    { userId },
    { timeoutMs: 20_000 },
  );
  if (Array.isArray(body)) return body as RemoteShiftRow[];
  return [];
}
